import { call, put, takeLatest } from 'redux-saga/effects';
import axios from 'axios';
import { REQUEST, fetchSuccess, fetchFailure } from '../../actions/datasources/connectImportFile';
import config from '../../../config';
import { getLocalUser } from '../../../utils/localUser';
import { Error as ErrorAction } from '../../actions/error/error';

// Import a staged file with a user-customised field mapping.
function* operation(action) {
  try {
    const res = yield call(
      axios.post,
      `${config.API_URL}/ingestion/connect/import-file`,
      action.payload.body,
      { headers: getLocalUser() },
    );
    yield put(fetchSuccess(res.data?.data || res.data));
  } catch (error) {
    yield put(ErrorAction(error));
    yield put(fetchFailure(error.response?.data?.error || error.message || 'Failed to connect.'));
  }
}

export function* watch() {
  yield takeLatest(REQUEST, operation);
}
